module.exports = __webpack_public_path__ + "img/O-que-considerar-ao-contratar-um-software-na-construcao-civil.da20d0db.jpg";